import { constants } from "../../../constants";
export const PageNotFound = () => (
  <div className="container h-full w-full z-50">
    <div className="flex">
      <div className="w-1/2 flex items-center justify-center h-screen">
        <div className="mt-200 ">
          <h2 className="text-4xl" id="test">
            Profile not found{" "}
          </h2>
          <p className="text-xl mt-4">
            {" "}
            This Page doesn`t exist!
            <br />
            <a
              className="bg-[#1937b2] border-none rounded-[50px] text-white inline-block text-[16px] font-bold mb-0 px-[30px] py-[10px] text-center touch-manipulation transition-all duration-300 align-middle whitespace-nowrap mt-4"
              href={import.meta.env.VITE_HOME_NAVIGATION_LINK}
            >
              Return to MyBharat
            </a>
          </p>
        </div>
      </div>
      <div className="w-1/2 flex items-center justify-center h-screen">
        {" "}
        <img src={constants.pageNotFoundURL} alt="404 image" className="img-fluid" />
      </div>
    </div>
  </div>
);
